export const experience = [
  {
    id: 1,
    company: "Amazon Web Services",
    role: "Software Development Engineer Intern",
    location: "Seattle, WA",
    period: "May 2025 – Aug 2025",
    type: "Internship",
    logo: "/images/aws-logo.png",
    description: [
      "Designed a recommendation portal for developer tool discovery, reducing search latency from 1.5 minutes to 10s",
      "Built scalable backend services with Java + GraphQL + DynamoDB, accelerating developer onboarding for 100K+ engineers",
      "Optimized caching and load balancing, cutting page load time by 40% and improving reliability across distributed teams",
    ],
    tags: ["Java", "GraphQL", "DynamoDB", "AWS"],
  },
  {
    id: 2,
    company: "CoRAL - Mayo Clinic",
    role: "Research Assistant",
    location: "Tempe, AZ",
    period: "Sep 2024 – May 2025",
    type: "Research",
    logo: "/images/mayo-logo.png",
    description: [
      "Built an agentic RAG system for clinical trial PDFs with single-document insight extraction",
      "Designed a novel prompting strategy for extracting and storing structured table & image representations",
      "Developed a structured-driven retrieval framework for answer attribution and explainability",
      "Benchmarked Agent using SOTA LLMs and achieved +10% accuracy vs OpenAI's file-search API at 1/3rd cost",
    ],
    tags: ["RAG", "LLMs", "Clinical AI", "Python"],
  },
  {
    id: 3,
    company: "Perceptive Analytics",
    role: "Analyst",
    location: "Hyderabad, India",
    period: "Jun 2023 – Jun 2024",
    type: "Full-time",
    logo: "/images/perceptive-logo.png",
    description: [
      "Collaborated with a financial institution to build a Retrieval-Augmented Generation (RAG) chatbot for analyzing market trends on proprietary and SEC datasets",
      "Built a multi-agent LLM framework with LangChain, automating insight extraction and market trend visualizations in Tableau",
      "Designed an interactive interface with Streamlit and deployed as a serverless function on AWS Lambda",
      "Reduced report turnaround time by 40%, saving 25+ analyst hours weekly",
    ],
    tags: ["LangChain", "AWS Lambda", "RAG", "Streamlit"],
  },
  {
    id: 4,
    company: "Subtl.ai",
    role: "NLP Engineer",
    location: "Hyderabad, India",
    period: "Dec 2022 – Feb 2023",
    type: "Part-time",
    logo: "/images/subtl-logo.png",
    description: [
      "Developed a multi-user chatbot for querying financial documents and Excel sheets, reducing manual analysis workload by 90%",
      "Deployed NLP pipelines with Docker + Jenkins and collaborated in Agile sprints, shipping incremental updates every 2 weeks",
      "Improved query relevance and response time by 26% through model fine-tuning (T5)",
    ],
    tags: ["NLP", "T5", "Docker", "Jenkins"],
  },
  {
    id: 5,
    company: "Lakehead University",
    role: "MITACS Research Fellow",
    location: "Thunder Bay, Canada",
    period: "May 2022 – Aug 2022",
    type: "Research",
    logo: "/images/lakehead-logo.png",
    description: [
      "Selected for a fully funded onsite Research internship through the prestigious Globalink MITACS research internship program",
      "Developed a knowledge-grounded counter-narrative generation pipeline for online hate speech, leveraging large-scale pre-trained language models GPT-2 and XNLG",
      "Engineered a multi-stage knowledge retrieval and generation system utilizing transformer-based keyphrase extraction and BM25-based retrieval",
    ],
    tags: ["NLP", "GPT-2", "Hate Speech", "Research"],
  },
  {
    id: 6,
    company: "Precog - IIIT Hyderabad",
    role: "Undergraduate Research Assistant",
    location: "Hyderabad, India",
    period: "Jan 2022 – Apr 2023",
    type: "Research",
    logo: "/images/iiith-logo.png",
    description: [
      "Formalized and developed a novel noise-reduction framework using sentence-transformer LLMs. Built a rumor-detection model ensembling LSTM and CNN models",
      "Developed an MLP regressor model using m-BERT embeddings to evaluate the quality of synthetic machine-generated code-mixed sentences",
      "Built NER models for hashtag segmentation, scraped and processed 3.3M hashtags from Twitter using a loosely supervised approach",
    ],
    tags: ["NLP", "BERT", "Social Media", "Research"],
  },
  {
    id: 7,
    company: "Indian School of Business",
    role: "Data Science Intern",
    location: "Hyderabad, India",
    period: "Jan 2022 – Apr 2022",
    type: "Internship",
    logo: "/images/isb-logo.png",
    description: [
      "Developed an LSTM-based Seq-to-Seq activity forecasting system using Scikit-learn, PyTorch, on Netease Music users, processing over 56 million records",
      "Leveraged distributed computing with Apache Spark for scalable data preprocessing and implemented sliding window and seasonal decomposition techniques",
      "Achieved 79% accuracy in activity forecasting",
    ],
    tags: ["LSTM", "PyTorch", "Spark", "Forecasting"],
  },
  {
    id: 8,
    company: "Aided",
    role: "Software Development Intern",
    location: "Remote",
    period: "Jan 2021 – Apr 2021",
    type: "Internship",
    logo: "/images/aided-logo.png",
    description: [
      "Developed a multi-user, MERN stack healthcare application serving special needs children, parents, and therapists",
      "Featured a synchronized scheduling and emailing system",
      "Utilized Docker for web app integration and deployed it via the NGINX local server",
    ],
    tags: ["MERN", "Docker", "Healthcare", "Full-stack"],
  },
];
